import * as yup from 'yup';

export const ResidentDocumentmanagementSchema = yup.object({
  type: yup.string().required(),
  residentId: yup.string().required(),
  information: yup.string().notRequired().nullable(),
  originDate: yup.date().required(),
});

export const DownloadResidentDocumentSchema = yup.object({
  residentId: yup.string().required(),
  awsFilePath: yup.string().required(),
});

export const UpdateResidentDocumentmanagementSchema = yup.object({
  id: yup.string(),
  type: yup.string().required(),
  information: yup.string().notRequired().nullable(),
  originDate: yup.date().required(),
  includeInHospitalExport: yup.boolean().nullable().notRequired(),
});

export const CreateResidentDocumentmanagementSchema = yup.object({
  type: yup.string().required(),
  information: yup.string().notRequired().nullable(),
  originDate: yup.date().required(),
});

export interface IResidentDocumentmanagementCreate {
  type: string;
  information: string | null;
  originDate: Date;
}

export interface IResidentDocumentmanagement {
  id: string;
  type: string;
  information: string | null;
  originDate: Date;
  createdAt: Date;
  fileName: string;
  awsFilePath: string;
  includeInHospitalExport?: boolean | null;
}

export interface IUpdateResidentDocumentmanagement extends IResidentDocumentmanagementCreate {
  id: string;
  includeInHospitalExport?: boolean | null;
}
